module.exports = __webpack_public_path__ + "img/7.8c6c4e37.png";